module.exports = __webpack_public_path__ + "img/liucheng5.29a0a001.png";